// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-tooltip{display:inline-block}.lc-am-tooltip .lc-am-text{display:unset;max-width:unset;white-space:unset;word-wrap:unset}", ""]);
// Exports
module.exports = exports;
